
export enum SmartCaptureFailingReasons {
	CameraChanged = 'Camera Changed',
	ManualInputProviderChange = 'Manual Input Provider Change',
	Unknown = 'Unknown'
}
